import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks';
import { ROUTES } from '../../constants';

interface AdminRouteProps {
  children: React.ReactElement;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, token } = useAppSelector((state) => state.auth);

  // If we have a token but user is not loaded yet, wait instead of redirecting.
  if (token && !user) {
    return null;
  }

  if (!user || user.role !== 'admin') {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  return children;
};

export default AdminRoute;

